import { createUseStyles } from "react-jss";
import { colors } from "../../styles/colors";

/**
 * Breakpoints match the ones the Sidebar already uses (899.95px is where the
 * nav collapses), so the page reflows on the same beat as its chrome.
 */
const useStyles = createUseStyles({
  contentMain: {
    overflow: "hidden",
    height: "var(--app-vh)",
  },
  containerHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: "15px 0px 15px 0px",
  },
  vehiculeRoot: {
    padding: "30px clamp(16px, 3vw, 30px)",
    overflowY: "auto",
    height: "var(--app-vh)",
    backgroundColor: colors.bgcolor,
    "@media (max-width:899.95px)": { paddingTop: "68px" },
  },
  divContent: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },

  /**
   * Two side-by-side panels above 900px, stacked below.
   *
   * This was `flexDirection: row` with no wrap and no query, so on a phone the
   * pair kept trying to sit side by side inside a viewport that could not hold
   * them: each child's 202px min-width plus the search field's intrinsic width
   * pushed the row past 100% and the second card was clipped off-screen (the
   * "COÛT TOTAL" tile in the report). flexWrap alone would not have fixed it,
   * because `flex: 1` on children with a min-width still refuses to shrink
   * below that floor.
   */
  divContentTCO: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: "15px",
    "& > *": {
      // Without an explicit basis a flex item's min-width defaults to auto,
      // which is the content width — the actual cause of the overflow.
      flex: "1 1 320px",
      minWidth: 0,
    },
    "@media (max-width:899.95px)": {
      flexDirection: "column",
      "& > *": { flex: "1 1 auto" },
    },
  },

  /**
   * Search + button. Side by side while there is room; stacked once the field
   * would be squeezed below a usable width, with the button full-width so it
   * stays an easy tap target.
   */
  divSearch: {
    display: "flex",
    flexDirection: "row",
    gap: "10px",
    alignItems: "flex-end",
    flexWrap: "wrap",
    "&>div": {
      marginBottom: 0,
      flex: "1 1 200px",
      minWidth: 0,
      "& .MuiFormControl-root": {
        marginTop: 0,
      },
    },
    "@media (max-width:599.95px)": {
      flexDirection: "column",
      alignItems: "stretch",
      "&>div": { flex: "1 1 auto" },
      "& button": { width: "100%" },
    },
  },

  subContainer2: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    // Was 202px, which combined with `flex: 1` set a hard floor the panel could
    // not go under on narrow screens.
    minWidth: 0,
    borderRadius: "15px",
    padding: "20px",
    backgroundColor: colors.surface,
    border: `1px solid ${colors.borderLight}`,
    flex: 1,
    gap: "15px",
    height: "fit-content",
    "@media (max-width:479.95px)": {
      padding: "16px",
    },
  },

  /** Placeholder tiles while the figures load — same footprint as CustomCost. */
  skeletonCard: {
    borderRadius: "15px",
  },

  divResultSearch: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    padding: "30px 0px 0px 0px",
  },
  divTextResult: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "10px",
  },
});

export default useStyles;
